module.exports = __webpack_public_path__ + "img/feature-api-support.ca13c53f.webp";